<form [formGroup]="form" >
<xpo-card >
    <xpo-card-header>
        <xpo-card-title>Lineal Foot Calculator</xpo-card-title>
    </xpo-card-header>

        <div layout="row" layout-align="center" style="padding-left: 12px;">
            <div class="lineal-ft-calc__shipment-info" layout="column">
                <div class="lineal-ft-calc_desktop">
                    <table style="border-spacing: 0;">
                        <tr style="border-bottom: 1px solid #bdbdbd; padding-top: 10px; padding-bottom: 10px;">
                            <th class="lineal-ft-calc__shipment-info-header" style="width: 40px;">
                                <h5></h5>
                            </th>
                            <th class="lineal-ft-calc__shipment-info-header">
                                <h5>Number <br/> of Pieces
                                </h5>
                            </th>
                            <th class="lineal-ft-calc__shipment-info-header" style="width: 104px;">
                                <h5 >Weight in LBS<mat-icon matTooltip="At least 1 weight needed" matTooltipPosition="above" matTooltipClass="primary-tooltip" class="icon-display">info</mat-icon></h5> 
                            </th>
                            <th class="lineal-ft-calc__shipment-info-header">
                                <h5>Length</h5>
                            </th>
                            <th class="lineal-ft-calc__shipment-info-header">
                                <h5>Width</h5>
                            </th>
                            <th class="lineal-ft-calc__shipment-info-header">
                                <h5>Height</h5>
                            </th>

                            <th class="lineal-ft-calc__shipment-info-header" style="width: 83px;">
                                <h5>Volume in <br/> ft.<sup>3</sup></h5>
                            </th>
                            <th class="lineal-ft-calc__shipment-info-header" style="width: 83px;">
                                <h5>Stacked in <br/> Area ft.<sup>2</sup></h5>
                            </th>
                            <th class="lineal-ft-calc__shipment-info-header" style="width: 83px;">
                                <h5>Density in <br/> lbs/ft.<sup>3</sup></h5>
                            </th>
                        </tr>
                        <ng-container formArrayName="commodities">
                            <tr *ngFor="let commodityForm of commodities.controls; let i = index" class="lineal-ft-calc__shipment-info-content-block" [formGroupName]="i">
                                <td style="width: 40px;">
                                    {{i +1 }})
                                </td>
                                <td >
                                    <input (ngModelChange)="checkInputValues(i)" class="lineal-ft-calc__shipment-info-col" matInput formControlName="pieceCnt" placeholder="Number" type="text" aria-label="pieces"
                                        maxlength="3" onkeypress='return (event.charCode >= 48 && event.charCode <= 57)'>
                                </td>
                                <td>
                                    <input (ngModelChange)="checkInputValues(i)" class="lineal-ft-calc__shipment-info-col" matInput formControlName="weight" placeholder="Weight" type="text" aria-label="weight" style="width: 104px;"
                                        maxlength="6" onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46'>
                                </td>
                                <td >
                                    <input (ngModelChange)="checkInputValues(i)" class="lineal-ft-calc__shipment-info-col" matInput formControlName="length" placeholder="Inches" type="text" aria-label="length"
                                        maxlength="6" onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46'>
                                </td>
                                <td >
                                    <input (ngModelChange)="checkInputValues(i)" class="lineal-ft-calc__shipment-info-col" matInput formControlName="width" placeholder="Inches" type="text" min="1" maxlength="6"
                                        aria-label="width" onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46'>
                                </td>
                                <td>
                                    <input (ngModelChange)="checkInputValues(i)" class="lineal-ft-calc__shipment-info-col" matInput formControlName="height" placeholder="Inches" type="text" aria-label="height"
                                        maxlength="6" onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46'>
                                </td>
                                <td>
                                    <input class="lineal-ft-calc__shipment-info-col" matInput formControlName="volume" type="text" aria-label="height"
                                    >
                                    <!-- disabled="true"> -->

                                </td>
                                <td>
                                    <input class="lineal-ft-calc__shipment-info-col" matInput formControlName="area" type="text" aria-label="height"
                                    >
                                </td>
                                <td>
                                    <input class="lineal-ft-calc__shipment-info-col" matInput formControlName="density" type="text" aria-label="height"
                                    >
                                </td>
                            </tr>
                        </ng-container>  
                    </table>
                </div>
            </div>
            <div *ngIf="errorMessage" style="padding-top: 10px; text-align: left; color: red;">
                {{errorMessage}}
            </div>
            <div class="lineal-ft-calc__add-rows-container" layout="row" layout-align="end center" flex>
                <span>Add</span>
                <input class="lineal-ft-calc__shipment-info-col add-lines" matInput type="text"  formControlName=rowsToAdd maxlength="2"  aria-label="Add Rows">
                <span>
                    <span>line(s)</span>
                    <button mat-button color="primary" (click)="addRowsClick()">+ ADD
                    </button>
                </span>
                <div style="padding-right: 16px; padding-top: 4px;">
                    <button mat-button color="primary" aria-label="Reset Calculator" (click)="resetClick()">Reset
                    </button>
                    <button mat-raised-button class="md-primary md-raised" aria-label="Perform Calculation" [disabled]="!isFormValid()"
                        (click)="calculateClick()">Calculate
                    </button>
                </div>
            </div>

            <div class="lineal-ft-calc__results-container" fxLayout='column' *ngIf="isCalculated" >
                <div class="lineal-ft-calc__results-els-applicable" fxLayout='row'>
                    <div fxFlex="25">
                        <div class="result-header">Lineal Feet Applicable
                        </div>
                        {{totals?.isLinealFeetApplicable}}
                    </div>
                </div>
                <div fxLayout='row' style="padding-top: 10px;">
                    <div fxFlex="25">
                        <div class="result-header">Total Piece Count
                        </div>
                        {{totals?.totalPieceCount}}
                    </div>

                    <div fxFlex="25">
                        <div class="result-header">Total Volume
                        </div>
                        {{totals?.totalVolume}} ft<sup>3</sup>
                    </div>

                    <div fxFlex="25">
                        <div class="result-header">Total Weight
                        </div>
                        {{totals?.totalWeight}} lbs
                    </div>

                    <div fxFlex="25">
                        <div class="result-header">Total Density
                        </div>
                        {{totals?.totalDensity}} lbs/ft<sup>3</sup>
                    </div>
                </div>
                <div fxLayout='row' style="padding-top: 10px;" >
                    <div fxFlex="25">
                        <div class="result-header">Total Lineal Feet
                        </div>
                        {{totals?.totalLinealFt}}
                    </div>

                    <div fxFlex="25">
                        <div class="result-header">Total Adjusted Volume
                        </div>
                        {{totals?.totalAdjustedVolume}} ft<sup>3</sup>
                    </div>

                    <div fxFlex="25">
                        <div class="result-header">Total Adjusted Weight
                        </div>
                        {{totals?.adjustedWeight}} lbs
                    </div>

                    <div fxFlex="25">
                        <div class="result-header">Total Adjusted Density
                        </div>
                        {{totals?.totalAdjustedDensity}} lbs/ft<sup>3</sup>
                    </div>
                </div>
                <div fxLayout='row' style="padding-top: 10px;">
                    <div fxFlex="25">
                        <div class="result-header">ELS Feet
                        </div>
                        {{totals?.elsFeet}}
                    </div>

                    <div fxFlex="25">
                        <div class="result-header">Total Stacked Area
                        </div>
                        {{totals?.totalArea}} ft<sup>2</sup>
                    </div>
                </div>

                <div fxLayout='row' style="padding-top: 10px;">
                    <div fxFlex="25">
                        <div class="result-header">Criteria1
                        </div>
                        {{totals?.isCriteria1 ? "Yes" : "No"}}
                    </div>
                    <div fxFlex="25">
                        <div class="result-header">Criteria2
                        </div>
                        {{totals?.isCriteria2 ? "Yes" : "No"}}
                    </div>
                    <div fxFlex="25">
                        <div class="result-header">Criteria3
                        </div>
                        {{totals?.isCriteria3 ? "Yes" : "No"}}
                    </div>
                    <div fxFlex="25">
                        <div class="result-header">ConditionB
                        </div>
                        {{totals?.isConditionB ? "Yes" : "No"}}
                    </div>
                </div>

                <div class="lineal-ft-calc__results-message" *ngIf="totals?.linealFtComment">
                    <div class="result-header">Lineal Foot Comments
                    </div>
                    {{totals?.linealFtComment}}
                </div>

                <div class="lineal-ft-calc__results-message" *ngIf="totals?.cuCapacityRemarks">
                    <div class="result-header">Cubic Capacity Comments
                    </div>
                    {{totals?.cuCapacityRemarks}}
                </div>

                <div class="lineal-ft-calc__results-message" *ngIf="totals?.excessiveLengthComment">
                    <div class="result-header">Excessive Length Comments
                    </div>
                    {{totals?.excessiveLengthComment}}
                </div>
            </div>
            <xpo-card-footer layout="row" layout-align="end center">
            </xpo-card-footer>
        </div>
</xpo-card>
</form>